export default __webpack_public_path__ + "static/media/image-wps-1.80376fb9.jpg";